/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import { useHistory } from 'react-router'
const useStyles = makeStyles((theme) => ({
  heading: {
    // color: 'white',
    fontWeight: 700,
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '18px',
      lineHeight: '20px',
    },
  },
  error: { fontSize: '14px' },
}))

export default ({ className, heading, error, url }) => {
  const classes = useStyles()
  const history = useHistory()
  const renderClass = className
    ? `${className} ${classes.heading}`
    : error
    ? `${classes.error} ${classes.heading}`
    : classes.heading

  return (
    <Typography className={renderClass} onClick={() => history.push(url)}>
      {heading}
    </Typography>
  )
}
